// Shared priority metadata — mirrors Task's `priority` enum (low/medium/high/
// critical) on the backend. `text` drives the flag icon color in
// TaskRow/TaskCard; `pill`/`dot` drive the selector in TaskDetailPage.
export const PRIORITY_META = {
  low: {
    label: 'Low',
    dot: 'bg-gray-400',
    text: 'text-gray-400 dark:text-gray-500',
    pill: 'bg-gray-100 text-gray-700 dark:bg-gray-700/60 dark:text-gray-200',
  },
  medium: {
    label: 'Medium',
    dot: 'bg-blue-500',
    text: 'text-blue-500 dark:text-blue-400',
    pill: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  },
  high: {
    label: 'High',
    dot: 'bg-amber-500',
    text: 'text-amber-500 dark:text-amber-400',
    pill: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  },
  critical: {
    label: 'Critical',
    dot: 'bg-red-500',
    text: 'text-red-500 dark:text-red-400',
    pill: 'bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-300',
  },
}

export const PRIORITY_ORDER = ['low', 'medium', 'high', 'critical']

export function priorityMeta(priority) {
  return PRIORITY_META[priority] || PRIORITY_META.medium
}
